import React, { useMemo } from 'react';
import {
  Box,
  Flex, Grid, GridItem,
  Popover,
  PopoverArrow,
  PopoverBody, PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';
import PINSAIAssistantLabel from '../PINSAIAssistantLabel';
import PINSAIIconButton from '../PINSAIIconButton';
import RequiredBadge from '../RequiredBadge';

const RequirementBlockCardHeader = ({ displayName, isRequired, isArchived = false, relatedQuestions = [] }) => {
  const color = useMemo(() => (isArchived ? colors.greyScale['800'] : colors.greyScale['900']), [isArchived]);

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Text
        color={color}
        dusk={`requirement-block_${displayName}`}
        textStyle="bodyMd600"
      >
        {displayName}
      </Text>

      {!!relatedQuestions.length && (
        <Popover placement="top" trigger="hover">
          <PopoverTrigger>
            <Box>
              <PINSAIIconButton
                aria-label="View Requirement Question Links Button"
              />
            </Box>
          </PopoverTrigger>
          <PopoverContent _hover={{ cursor: 'default' }} maxW="1000px" p={4}>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverBody>
              <PINSAIAssistantLabel mb={4} w="333px" />
              <Text
                color="greyScale.700"
                mb={6}
                textAlign="left"
                textStyle="bodyXxl600"
              >
                {`Linked Questions (${relatedQuestions.length})`}
              </Text>
              <Box
                bg={colors.greyScale['75']}
                marginTop="0 !important"
                maxHeight="400px"
                overflowY="auto"
                px={2}
                width="100%"
              >
                <Grid
                  bg="inherit"
                  color={colors.greyScale['800']}
                  gap={6}
                  gridTemplateColumns="repeat(10, 1fr);"
                  h="44px"
                  position="sticky"
                  py={2}
                  rowGap={6}
                  textStyle="bodySm500"
                  top="initial"
                  width="100%"
                  zIndex="initial"
                >
                  <GridItem alignSelf="center" colSpan={4} justifySelf="left" ml={2}>Question Name</GridItem>
                  <GridItem alignSelf="center" colSpan={5} justifySelf="left" mr={2}>Question Description</GridItem>
                  <GridItem alignSelf="center" colSpan={1} justifySelf="left" mr={2} />
                </Grid>
              </Box>
              <Box
                maxH="200px"
                overflowY="auto"
                px={2}
              >
                {relatedQuestions.map(q => {
                  const question = q?.question;

                  return (
                    <Box
                      bg="white"
                      key={q?.id}
                      marginTop="0 !important"
                      maxHeight="400px"
                      overflowY="auto"
                      width="100%"
                    >
                      <Grid
                        bg="inherit"
                        gap={6}
                        gridTemplateColumns="repeat(10, 1fr);"
                        position="sticky"
                        py={2}
                        rowGap={6}
                        textStyle="bodySm"
                        top="initial"
                        width="100%"
                        zIndex="initial"
                      >
                        <GridItem alignSelf="center" colSpan={4} justifySelf="left" ml={2} mr={10} textStyle="bodyMd500">{question.name}</GridItem>
                        <GridItem alignSelf="center" colSpan={5} justifySelf="left" mr={2} textStyle="bodyMd">{question.question}</GridItem>
                        <GridItem alignSelf="center" colSpan={1} justifySelf="center" mr={2} />
                      </Grid>
                    </Box>
                  );
                })}
              </Box>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}
      {(isRequired && !isArchived) ? <RequiredBadge /> : null}
    </Flex>
  );
};

RequirementBlockCardHeader.propTypes = {
  displayName: PropTypes.string,
  isRequired: PropTypes.bool,
  isArchived: PropTypes.bool,
  relatedQuestions: PropTypes.arrayOf(PropTypes.object)
};

export default RequirementBlockCardHeader;
